import { Add, Remove } from "@mui/icons-material";
import { Button, IconButton, TextField } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import PropTypes from "prop-types";

function ValueSelector({ value, maxValue, onChange }) {
  const mv = maxValue || 0;

  const add = () => {
    const newVal = value < mv ? value + 1 : mv;
    onChange(newVal);
  };
  const subtract = () => {
    const newVal = value > 0 ? value - 1 : 0;
    onChange(newVal);
  };

  return (
    <Stack direction="row">
      <IconButton onClick={subtract}>
        <Remove color="" fontSize="large" />
      </IconButton>
      <TextField
        sx={{ width: "2em" }}
        inputProps={{
          sx: {
            textAlign: "center",
            fontSize: "1.5em",
          },
        }}
        variant="standard"
        value={value}
      />
      <IconButton onClick={add}>
        <Add color="" fontSize="large" />
      </IconButton>
    </Stack>
  );
}

ValueSelector.propTypes = {
  value: PropTypes.number.isRequired,
  maxValue: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export default ValueSelector;
